import React from 'react';
import styled from 'styled-components';
import { track } from '../../analytics/utils';
import {
  Button,
  Center,
  Flex,
  Padding,
  scrollToRefObject,
  Stack,
  Text,
} from '../../components';

const HeaderImageWrapper = styled.div<any>`
  background-image: url(${({ url }) => url});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 575px;
  width: 100%;
`;

const TextWrapper = styled.div<any>`
  width: 100%;
`;

export const HeaderModuleDesktop = (props) => {
  let { reference } = props;
  const executeScroll = () => {
    track('Learn More', {
      link_cta: 'Learn More',
      template: 'careers',
      section_name: 'Join Our Team',
    });
    scrollToRefObject(reference);
  };
  return (
    <Flex row>
      <Flex flex={2}>
        <HeaderImageWrapper url="images/header-module-picture.jpg" />
      </Flex>

      <Flex flex={1} backgroundRole="primary">
        <Center height="100%">
          <TextWrapper>
            <Padding size={[6, 5, 6, 5]}>
              <Stack size={4}>
                <Text textType="heading2_desktop" align="left">
                  Join our team
                </Text>

                <Text textType="primary2" align="left">
                  Glossier is giving voice through beauty as a
                  direct-to-consumer company that leverages the power of
                  personal narrative to own the beauty conversation on the
                  internet.
                </Text>

                <Padding>
                  <Button
                    borderSize={[1]}
                    radius="small"
                    borderRole="grey"
                    backgroundRole="black"
                    textRole="secondary"
                    onClick={executeScroll}
                  >
                    Learn More
                  </Button>
                </Padding>
              </Stack>
            </Padding>
          </TextWrapper>
        </Center>
      </Flex>
    </Flex>
  );
};
